import * as yup from "yup";

export default yup.object().shape({
  email: yup
    .string()
    .required("É necessário informar um e-mail.")
    .email("E-mail inválido."),
  password: yup.string().required("É necessário informar uma senha."),
});
